import React from "react";

import { BrowserRouter as Router, Route, Link, Routes, Redirect, useLocation } from 'react-router-dom';

import FrontPage from '../components/FrontPage'
import Archive from '../layouts/Archive'
import SinglePost from '../layouts/SinglePost';
import Pages from '../layouts/Pages';
import SinglePage from '../layouts/SinglePage';
import SingleProgramme from '../layouts/SingleProgramme';

import Categories from '../layouts/Categories';
import SingleCategory from '../layouts/SingleCategory';
import Tags from '../layouts/Tags';
import SingleTag from '../layouts/SingleTag';
import NotFound from '../layouts/NotFound';


function RmsRoutes() {

    const location = useLocation();

    console.log('Current route:', location.pathname);
    return (
        <div id="main" className="playeron">
            <div className="container">
                <div className="row">
                    <Routes>
                        <Route exact path='/' Component={FrontPage} />
                             
                        
                        <Route path='/programme/:slug' Component={SingleProgramme} />
                        <Route exact path='/:id' Component={SinglePage} />
 
                        
                        <Route path='/archive/page/:page' Component={Archive} />
                        <Route exact path='/archive/:id' Component={SinglePost} />
                        <Route path='/pages/page/:page' Component={Pages} />                        
                        <Route exact path='/category/page/:page' Component={Categories} />
                        <Route path='/category/:id/page/:page' Component={SingleCategory} />
                        <Route exact path='/tag/page/:page' Component={Tags} />
                        <Route path='/tag/:tag/page/:page' Component={SingleTag} />
                        
                        <Route path='*' Component={NotFound} />

                    </Routes>
                </div>
            </div>
        </div>
    )

}
export default RmsRoutes;